import { render, staticRenderFns } from "./DrawingSpace.vue?vue&type=template&id=c57931fa&scoped=true&"
import script from "./DrawingSpace.vue?vue&type=script&lang=js&"
export * from "./DrawingSpace.vue?vue&type=script&lang=js&"
import style0 from "./DrawingSpace.vue?vue&type=style&index=0&id=c57931fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57931fa",
  null
  
)

export default component.exports